export default __webpack_public_path__ + "28c69082cb837acc57dd6ef0567a3126.png";